import moment from 'moment'
export default {
  props: ['finalList', 'fareSelected', 'removeSeconds', 'getFormatedTime'],
  methods: {
    formatMyDate(date) {
      return moment(date).format("DD-MMM-YY")
    },
    getArrivalDate() {
      return moment(this.flight.arrival_datetime).format("YYYY-MM-DD")
    },
  }
}
